import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import { getUpdatedLocationFulfillmentOptions } from 'bento-ordering/base/constants/endpoints';
import {
  UPDATE_FULFILLMENT_OPTIONS_REQUEST,
  UPDATE_FULFILLMENT_OPTIONS_SUCCESS,
  UPDATE_FULFILLMENT_OPTIONS_FAILURE
} from 'bento-ordering/locations/constants/actionTypes';
import getGroupOrderQueryParam from 'bento-ordering/base/utils/getGroupOrderQueryParam';

export const updateFulfillmentOptionsForLocation = locationId => (
  dispatch,
  getState
) => {
  const state = getState();
  const endpoint = getUpdatedLocationFulfillmentOptions(locationId);
  const types = [
    UPDATE_FULFILLMENT_OPTIONS_REQUEST,
    UPDATE_FULFILLMENT_OPTIONS_SUCCESS,
    UPDATE_FULFILLMENT_OPTIONS_FAILURE
  ];
  const queryParams = getGroupOrderQueryParam(state);

  return dispatch(apiAction(endpoint, 'GET', types, null, queryParams));
};

export const updateFulfillmentOptionsForCartLocation = () => (
  dispatch,
  getState
) => {
  const { cart } = getState();
  if (cart.online_ordering_location) {
    dispatch(
      updateFulfillmentOptionsForLocation(cart.online_ordering_location)
    );
  }
};
